  
  var logoIsBlack = false;
   
  function switchHeaderWhite() {
    switchLogo(true);
    $(".ayaq-home-link").attr("style", "color:black !important;");
    $(".ayaq-header-container").attr("style", "color:black; background-color: #FFFFFF !important;");
  };
  function switchHeaderTransparent() {
    switchLogo(false);
    $(".ayaq-home-link").attr("style", "color:white !important;");
    $(".ayaq-header-container").attr("style", "color:white; background-color: rgba(150, 150,150, 0.5);");
  };
  
  function switchLogo(isBlack){
    if ((isBlack && logoIsBlack) || (!isBlack && !logoIsBlack)) return;
    logoIsBlack = isBlack;
    var logo = isBlack ?  logoBlack : logoWhite;
    $('#ayaq_logo').attr('src', logo);
    $('#ayaq_logo').attr('srcset', logo);
    
    $('.icon-hamburger').css('color', isBlack ? '#000000 !important' : '#FFFFFF');
     $(".header__icons .icon").attr("style", isBlack ? 'color:#000000 !important' : 'color:#FFFFFF !important');
    $(".fa-map-marker-alt").attr("style", isBlack ? 'color:#000000 !important; font-size:22px;  padding:0px 20px 0px 0px;' : 'color:#FFFFFF !important; font-size:22px;  padding:0px 20px 0px 0px;');
    $(".header-partnershops").attr("style", isBlack ? 'color:#000000 !important; padding-top:10px;' : 'color:#FFFFFF !important;  padding-top:10px;');
    
  }
  document.addEventListener("DOMContentLoaded", function(event) {

    var universes_exists = !!$("#top-universes").length;
    var secondary_exists = !!$("#secondary_bar").length;
    if (universes_exists && secondary_exists){
      $("#MainContent").css("margin-top","40px");
    }

    window.onscroll = function() {
      try{
        var height = document.getElementById('site-header').offsetHeight;
        //1. Hide or Show Universes bar
        if ( window.pageYOffset > height+200 ) {
          $("#top-universes").fadeOut();
          //$("#secondary_bar").fadeOut();
        } else {
          $("#top-universes").fadeIn();
          //$("#secondary_bar").fadeIn();
        }
        
        //2. Switch background color
        if (!!shop_template && shop_template === "index"){
          if ( window.pageYOffset > height+200 ) {
            switchHeaderWhite();
          } else {
            switchHeaderTransparent();
          }
        }
      }
      catch(e){
        
      }
    }


    
    if (!!shop_template && shop_template === "index"){
      $('#menu1').hover(switchHeaderWhite, switchHeaderTransparent);
    }
    
    var header = document.getElementById('site-header');
    var main = document.getElementById('MainContent');
    var headerHeight = header.offsetHeight;
    document.getElementById('MainContent').style.setProperty('--header-height', '-'+ headerHeight + 'px');

    document.getElementById("header-menu").addEventListener('click',function () {
      var sideMenu = document.getElementById('Details-menu-drawer-container');
      var height = header.offsetHeight;
      if ( window.pageYOffset < height ) {
      if (!sideMenu.classList.contains('menu-opening')) {
        header.classList.remove('site-header-transparent');
      } else {
        header.classList.add('site-header-transparent');
      }
      }
    });

    let itemsContainer = document.querySelector(".header__inline-menu");
    if (!!itemsContainer){
      try{
        let items = itemsContainer.querySelectorAll("details");
        items.forEach(item => {
          item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            item.querySelector("ul").addEventListener("mouseleave", () => {
              item.removeAttribute("open");
            });
            item.addEventListener("mouseleave", () => {
              item.removeAttribute("open");
            });
          });
        
        });
      }catch(e){
        console.log(e);
      }
    }



    const trigger = document.getElementById('ayaq-search-trigger');
    const searchBar = document.getElementById('ayaq-search-bar');

    function closeSearchBar() {
      if (searchBar) searchBar.style.display = 'none';
    }

    if (trigger && searchBar) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        const isVisible = searchBar.style.display === 'block';
        searchBar.style.display = isVisible ? 'none' : 'block';
        if (!isVisible) {
          const input = searchBar.querySelector('input[type="search"]');
          if (input) input.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (!searchBar.contains(e.target) && !trigger.contains(e.target)) {
          closeSearchBar();
        }
      });

      window.addEventListener('scroll', function () {
        closeSearchBar();
      });
    }




    document.querySelectorAll('.ayaq-li-menu1').forEach(function(menuItem) {
      const submenu = menuItem.querySelector('.ayaq-submenu-container');

      // Gérer l'affichage du sous-menu au survol
      menuItem.addEventListener('mouseenter', function() {
        closeAllSubmenus(); // Fermer tous les autres sous-menus
        if (submenu) {
          submenu.classList.add('open'); // Ouvrir le sous-menu de cet élément
        }
      });

      // Gérer la fermeture du sous-menu quand la souris quitte
      menuItem.addEventListener('mouseleave', function() {
        if (submenu) {
          submenu.classList.remove('open'); // Fermer le sous-menu du menu quitté
        }
      });
    });

    // Fonction pour fermer tous les sous-menus
    function closeAllSubmenus() {
      document.querySelectorAll('.ayaq-submenu-container.open').forEach(function(openSubmenu) {
        openSubmenu.classList.remove('open'); // Fermer tous les sous-menus ouverts
      });
    }


    customElements.define('sticky-header', StickyHeader);
    
  });


class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this || !this.header) return;
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      if (!this || !this.header) return;
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this || !this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {return;
      if (!this || !this.header || !this.predictiveSearch || !this.currentScrollTop || !this.headerBounds) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      //this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this || !this.header) return;
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this || !this.header || !this.header.classList) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this || !this.header || !this.header.classList) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this || !this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      if (!this.disclosures) return;
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this || !this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }

  